import React from 'react'

import { Order, OrderLineItem } from '../../types'

interface OrderSummaryProps {
  order: Order
}

export const OrderSummary: React.FC<OrderSummaryProps> = ({ order }) => {
  const lineItems = order.lineItems ?? []

  return (
    <div className="user-profile-order-summary">
      <div className="user-profile-order-summary__items">
        {lineItems.map((item) => (
          <LineItem key={item.id} item={item} />
        ))}
      </div>

      <div className="user-profile-order-summary__totals">
        <Row label="Subtotal" value={order.totalPriceFormatted} />
        {order.totalDeliveryCostMoney ? <Row label="Delivery" value={order.totalDeliveryCostMoneyFormatted} /> : null}
        {order.totalShippingCostMoney ? <Row label="Shipping" value={order.totalShippingCostMoneyFormatted} /> : null}
        {order.totalDiscountMoney ? <Row label="Discount" value={`-${order.totalDiscountMoneyFormatted}`} /> : null}
        {order.totalTaxMoney ? <Row label="Tax" value={order.totalTaxMoneyFormatted} /> : null}
        {order.driverTipMoney ? <Row label="Tip" value={order.driverTipMoneyFormatted} /> : null}
        {order.totalGiftCardMoney ? (
          <Row label="Paid with Gift Card" value={`-${order.totalGiftCardMoneyFormatted}`} />
        ) : null}
        <Row bold label="Total" value={order.totalMoneyFormatted} />
      </div>
    </div>
  )
}

const LineItem: React.FC<{ item: OrderLineItem }> = ({ item }) => {
  const { orderable } = item
  const modifiers = item.modifiers ?? []

  return (
    <div className="user-profile-order-summary__item">
      <div className="user-profile-order-summary__item-main">
        <span className="user-profile-order-summary__item-qty">{item.quantity}×</span>
        <div className="user-profile-order-summary__item-details">
          <div className="user-profile-order-summary__item-name">
            {orderable.name}
            {orderable.variantName ? ` — ${orderable.variantName}` : ''}
          </div>
          {modifiers.length > 0 && (
            <div className="user-profile-order-summary__item-modifiers">
              {modifiers.map((modifier) => modifier.name).join(', ')}
            </div>
          )}
          {item.note && <div className="user-profile-order-summary__item-note">Note: {item.note}</div>}
        </div>
      </div>
      {item.totalMoneyFormatted ? (
        <span className="user-profile-order-summary__item-price">{item.totalMoneyFormatted}</span>
      ) : (
        <span className="user-profile-order-summary__item-price" />
      )}
    </div>
  )
}

interface RowProps {
  bold?: boolean
  label: string
  value?: string
}

const Row: React.FC<RowProps> = ({ label, value, bold }) => {
  if (!value) return null

  return (
    <div
      className={
        bold
          ? 'user-profile-order-summary__row user-profile-order-summary__row_total'
          : 'user-profile-order-summary__row'
      }
    >
      <span>{label}</span>
      <span>{value}</span>
    </div>
  )
}
